import type { SessionUser } from '@/types/auth'

const SESSION_KEY = 'zsj-business-session'

export function readSession(): SessionUser | null {
  const value = localStorage.getItem(SESSION_KEY)
  if (!value) return null
  try {
    const session = JSON.parse(value) as Partial<SessionUser>
    if (!session.token || !session.name || !Array.isArray(session.permissions)) return null
    return session as SessionUser
  } catch {
    return null
  }
}

export function writeSession(session: SessionUser): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
}

export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY)
}
